"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubjectYearSerializer = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
class SubjectYearSerializer extends dp_http_client_lib_1.PageableSerializer {
    serializeOne(row) {
        return {
            id: row.id,
            globalId: row.globalId,
            subject: row.subject,
            subjectId: row.subjectId,
            name: row.name,
            year: row.year,
            metadata: row.metadata,
        };
    }
    serializeSubjectYearSearch(data) {
        const items = data.data.map((sy) => {
            return {
                id: sy.id,
                globalId: sy.globalId,
                subject: sy.subject,
                subjectId: sy.subjectId,
                name: sy.name,
                year: sy.year,
                providerId: sy.providerId,
                metadata: sy.metadata,
            };
        });
        const pagination = {
            page: data.meta.page,
            limit: data.meta.limit,
            itemsCount: data.meta.itemsCount,
            pagesCount: data.meta.pagesCount,
            hasPreviousPage: data.meta.hasPreviousPage,
            hasNextPage: data.meta.hasNextPage,
        };
        return { data: items, meta: pagination };
    }
}
exports.SubjectYearSerializer = SubjectYearSerializer;
//# sourceMappingURL=subject-year.serializer.js.map